// Base URL passed to report requests so generated HTML can link back into the app
export const rootUrl = location.origin + '/ems/'
